/* eslint-disable @angular-eslint/prefer-standalone */
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zipCode',
  standalone: false
})


@Injectable({
  providedIn: 'root'
})


export class ZipCodePipe implements PipeTransform {
  transform(value: number | string): string {
    let document = value + '';
    document = document.replace(/\D/g, '');
    if (document.length === 8) {
        return document.replace(/(\d{5})(\d{3})/, '$1-$2');
    } else {
        return document;
    }
  }
}
